import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useSurfaceStore } from 'pinia/surface'
import { useSurfaceMapStore } from 'pinia/surface_map'
import { useSurfaceSettingsStore } from 'pinia/surface_settings'
import { useSurfacePostPropertiesStore } from 'pinia/surface_post_properties'
import { defineAsyncComponent, onBeforeMount } from 'vue'
import { SettingsSubpanel } from 'vuexstore/modules/surface_settings'

export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSettingsPanel',
  setup(__props) {

const SurfaceSettingsIconPanel = defineAsyncComponent(() => import('vuecomponents/SurfaceSettingsIconPanel.vue'))
const SurfaceSettingsMainPanel = defineAsyncComponent(() => import('vuecomponents/SurfaceSettingsMainPanel.vue'))
const SurfaceSettingsMapStylePanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsMapStylePanel.vue'),
)
const SurfaceSettingsReactionsPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsReactionsPanel.vue'),
)
const SurfaceSettingsWallpaperPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsWallpaperPanel.vue'),
)
const SurfaceSettingsSortPostsPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsSortPostsPanel.vue'),
)
const SurfaceSettingsSectionGroupPostsPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsSectionGroupPostsPanel.vue'),
)
const SurfaceSettingsPostPropertiesPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsPostPropertiesPanel.vue'),
)
const SurfaceSettingsPostPropertiesCustomFieldPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSettingsPostPropertiesCustomFieldPanel.vue'),
)

const { activePanel } = storeToRefs(useSurfaceSettingsStore())
const { xCustomPostPropertiesPanel } = storeToRefs(useSurfacePostPropertiesStore())
const { fetchMapThemes } = useSurfaceMapStore()
const { isMap } = storeToRefs(useSurfaceStore())

onBeforeMount(() => {
  if (isMap.value) {
    fetchMapThemes()
  }
})

return { __sfc: true,SurfaceSettingsIconPanel, SurfaceSettingsMainPanel, SurfaceSettingsMapStylePanel, SurfaceSettingsReactionsPanel, SurfaceSettingsWallpaperPanel, SurfaceSettingsSortPostsPanel, SurfaceSettingsSectionGroupPostsPanel, SurfaceSettingsPostPropertiesPanel, SurfaceSettingsPostPropertiesCustomFieldPanel, activePanel, xCustomPostPropertiesPanel, fetchMapThemes, isMap, SettingsSubpanel }
}

})